import React from 'react';
import Video from "../main/Video";
import Text from "../main/Text";

export default function ProductCare(props) {
    const videoUrl = `${process.env.PUBLIC_URL}/videos/testvideo.mp4`;

    return (
        <>
            <Text>
                <p>
                    This is product video care page
                </p>
            </Text>
            <Video url={videoUrl} maxHeight="80%" />
        </>
    )
}
